/**
* DevExpress HTML/JS Reporting (designer\internal\_dataBindingMode.js)
* Version:  24.1.7
* Build date: Oct 28, 2024
* Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
* License: https://www.devexpress.com/Support/EULAs/universal.xml
*/
export var DataBindingMode;
(function (DataBindingMode) {
    DataBindingMode["Bindings"] = "Bindings";
    DataBindingMode["Expressions"] = "Expressions";
    DataBindingMode["ExpressionsAdvanced"] = "ExpressionsAdvanced";
})(DataBindingMode || (DataBindingMode = {}));
